import type { JSX } from 'react';

import { Box, Container, Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import { EmbeddedVideo } from 'src/app/shared/components/embeddedMedia';

type YouTubeEmbedProps = {
	src: string;
	title: string;
};

function YoutubeEmbed({ src, title }: YouTubeEmbedProps) {
	const html = `<iframe
			src="${src}"
			title="${title}"
			frameBorder="0"
			allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
			allowFullScreen
		/>`;
	return <EmbeddedVideo embedHtml={html} aspectRatio="16/9" />;
}

export function TitleSection(): JSX.Element {
	return (
		<>
			<Box sx={{ height: [150, 600], backgroundColor: '#fdf9f2' }}>
				<Container px={[8, 16]} sx={{ height: '100%' }}>
					<Flex
						pb={[0, 380]}
						sx={{
							height: '100%',
							width: '100%',
							flexDirection: 'column',
							alignItems: 'center',
							justifyContent: 'center',
						}}
					>
						<Heading sx={{ textAlign: 'center' }} as="h1" size={['h2', 'h1']}>
							Change.org Racial Justice Fund
						</Heading>
					</Flex>
				</Container>
			</Box>
			<Box mt={[0, -380]}>
				<Container px={[0, 16]}>
					<Box sx={{ aspectRatio: '16/9' }}>
						<YoutubeEmbed
							src="https://www.youtube-nocookie.com/embed/qlfJPMlAx5M"
							title="Change.org Racial Justice Fund Information Video"
						></YoutubeEmbed>
					</Box>
				</Container>
			</Box>
		</>
	);
}
